import clsx from 'clsx';
import { ChevronDownIcon } from '../../../../../shared/ui/icons';
import { Button } from '../../../../../shared/ui/button/Button';
import selectStyles from '../../../../../shared/ui/select/Select.module.css';
import { useDropdownMenu } from '../../../../../shared/hooks';
import styles from '../CreateTemplateButton.module.css';
import { TEXT_TEMPLATE_CREATE_OPTIONS } from '../lib/constants';

export function TextTemplateCreateButton({ size = 'sm', onClick, className = '' }) {
  const { rootRef, open, toggleOpen, close } = useDropdownMenu();

  return (
    <div ref={rootRef} className={clsx(styles.root, className)}>
      <Button
        className={clsx(open && styles.triggerOpen)}
        onClick={toggleOpen}
        size={size}
        variant="primary"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Create Text Template"
      >
        <span>Create Template</span>
        <ChevronDownIcon className={clsx(styles.chevron, open && styles.chevronOpen)} />
      </Button>

      {open ? (
        <div
          className={clsx(selectStyles.menu, styles.menu)}
          role="menu"
          aria-label="Choose text template type"
        >
          {TEXT_TEMPLATE_CREATE_OPTIONS.map((option) => (
            <button
              key={option.key}
              type="button"
              role="menuitem"
              className={clsx(selectStyles.option, styles.option)}
              onClick={() => {
                close();
                onClick?.(option.key);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
